/* eslint-disable no-console */
export default class StandardOperation {
  constructor(operation) {
    this.validTypes = ['SME', 'MORTGAGE', 'PARKING', 'HOME_EQUITY', 'COMPLEMENTARY'];
    this.validCountries = ['CL', 'BR', 'PE'];

    this.validations = {
      CL: {
        SME: {
          annualRate: v => v,
          considerLate: v => this.validateEmpty(v, 'considerLate'),
          approvedAmount: v => v,
          insuredAmount: v => v,
          installmentsToShow: v => v,
          investorName: v => this.validateEmpty(v, 'investorName'),
          isActive: v => this.validateEmpty(v, 'isActive'),
          payments: (v, op) => this.validatePayments(v, op),
          debtorLastName: v => v || ''
        },
        PARKING: {
          debtorLastName: v => v || '', // En empresas no aplica
          debtorSecondLastName: v => v, // En empresas no aplica
          debtorBirthdate: v => this.validateOperationDate(v, 'debtorBirthdate', true), // En empresas no aplica
          debtorAddress: v => this.validateEmpty(v, 'debtorAddress'),
          considerLate: (v, op) => this.validateConsiderLates(v, 'considerLate', op),
          considerLateInterest: (v, op) => this.validateConsiderLates(v, 'considerLateInterest', op),
          considerLateCharges: (v, op) => this.validateConsiderLates(v, 'considerLateCharges', op),
          approvedAmount: v => this.validateEmpty(v, 'approvedAmount'),
          installmentsToShow: v => this.validateEmpty(v, 'installmentsToShow'),
          investorName: v => this.validateEmpty(v, 'investorName'),
          firstPayment: (v, op) => this.validateAccordingLoadTD(v, 'firstPayment', op),
          spread: (v, op) => this.validateAccordingLoadTD(v, 'spread', op),
          amortization: v => v, // Cuándo trae TD no es necesario
          payments: (v, op) => this.validatePayments(v, op),
          isActive: v => this.validateEmpty(v, 'isActive')
        }
      },
      BR: {
        MORTGAGE: {
          debtorLastName: v => this.validateEmpty(v, 'debtorLastName'),
          debtorBirthdate: v => this.validateOperationDate(v, 'debtorBirthdate', false),
          debtorAddressCEP: v => this.validateEmpty(v, 'debtorAddressCEP'),
          codebtorBirthdate: v => this.validateOperationDate(v, 'codebtorBirthdate', true),
          debtorAddress: v => this.validateEmpty(v, 'debtorAddress'),
          annualRate: v => this.validateEmpty(v, 'annualRate'),
          considerLate: v => this.validateEmpty(v, 'considerLate'),
          approvedAmount: v => this.validateEmpty(v, 'approvedAmount'),
          amortizationMethod: v => this.validateEmpty(v, 'amortizationMethod'),
          propertyAmount: v => this.validateEmpty(v, 'propertyAmount'),
          installmentsToShow: v => this.validateEmpty(v, 'installmentsToShow'),
          investorName: v => this.validateEmpty(v, 'investorName'),
          dueDay: v => this.validateEmpty(v, 'dueDay'),
          debtorLifeInsuranceType: v => this.validateEmpty(v, 'debtorLifeInsuranceType'),
          codebtorLifeInsuranceType: v => v,
          propertyInsuranceType: v => this.validateEmpty(v, 'propertyInsuranceType'),
          creditInsuranceNumberOfMonths: v => this.validateEmpty(v, 'creditInsuranceNumberOfMonths'),
          monthlyCreditInsurance: v => this.validateEmpty(v, 'monthlyCreditInsurance'),
          creditInsuranceRate: v => this.validateEmpty(v, 'creditInsuranceRate'),
          creditInsuranceOuterProportion: v => this.validateEmpty(v, 'creditInsuranceOuterProportion'),
          creditInsurancePrizeProportion: v => this.validateEmpty(v, 'creditInsurancePrizeProportion'),
          considerTAC: v => this.validateEmpty(v, 'considerTAC'),
          considerNegativeInflation: v => this.validateEmpty(v, 'considerNegativeInflation'),
          upperBoundBehaviour: v => this.validateEmpty(v, 'upperBoundBehaviour'),
          inflationaryUpperBound: v => this.validateEmpty(v, 'inflationaryUpperBound'),
          firstPayment: v => this.validateOperationDate(v, 'firstPayment', false),
          isActive: v => this.validateEmpty(v, 'isActive')
        },
        HOME_EQUITY: {
          debtorLastName: v => this.validateEmpty(v, 'debtorLastName'),
          debtorBirthdate: v => this.validateOperationDate(v, 'debtorBirthdate', false),
          debtorAddressCEP: v => this.validateEmpty(v, 'debtorAddressCEP'),
          codebtorBirthdate: v => this.validateOperationDate(v, 'codebtorBirthdate', true),
          debtorAddress: v => this.validateEmpty(v, 'debtorAddress'),
          annualRate: v => this.validateEmpty(v, 'annualRate'),
          considerLate: v => this.validateEmpty(v, 'considerLate'),
          approvedAmount: v => this.validateEmpty(v, 'approvedAmount'),
          amortizationMethod: v => this.validateEmpty(v, 'amortizationMethod'),
          propertyAmount: v => this.validateEmpty(v, 'propertyAmount'),
          installmentsToShow: v => this.validateEmpty(v, 'installmentsToShow'),
          investorName: v => this.validateEmpty(v, 'investorName'),
          dueDay: v => this.validateEmpty(v, 'dueDay'),
          debtorLifeInsuranceType: v => this.validateEmpty(v, 'debtorLifeInsuranceType'),
          codebtorLifeInsuranceType: v => v,
          propertyInsuranceType: v => this.validateEmpty(v, 'propertyInsuranceType'),
          creditInsuranceNumberOfMonths: v => this.validateEmpty(v, 'creditInsuranceNumberOfMonths'),
          monthlyCreditInsurance: v => this.validateEmpty(v, 'monthlyCreditInsurance'),
          creditInsuranceRate: v => this.validateEmpty(v, 'creditInsuranceRate'),
          creditInsuranceOuterProportion: v => this.validateEmpty(v, 'creditInsuranceOuterProportion'),
          creditInsurancePrizeProportion: v => this.validateEmpty(v, 'creditInsurancePrizeProportion'),
          considerTAC: v => this.validateEmpty(v, 'considerTAC'),
          considerNegativeInflation: v => this.validateEmpty(v, 'considerNegativeInflation'),
          upperBoundBehaviour: v => this.validateEmpty(v, 'upperBoundBehaviour'),
          inflationaryUpperBound: v => this.validateEmpty(v, 'inflationaryUpperBound'),
          firstPayment: v => this.validateOperationDate(v, 'firstPayment', false),
          isActive: v => this.validateEmpty(v, 'isActive')
        }
      }
    };

    const { type, country } = operation;
    if (!this.validTypes.includes(type)) throw new Error(`invalid type: ${type}`);
    if (!this.validCountries.includes(country)) throw new Error(`invalid country: ${country}`);

    this.operations = this.applyValidations(operation);

    delete this.operations.loadTD;
    delete this.operations.skip;
    delete this.operations.loadFieldsFromRegisterProcess;
    delete this.operations.country;

    return this.operations;
  }

  getCommonmFields() {
    const commonFields = {
      signatureDate: v => this.validateOperationDate(v, 'signatureDate', false),
      debtorIdNumber: v => v,
      debtorName: v => this.validateEmpty(v, 'debtorName'),
      debtorEmail: v => this.validateEmpty(v, 'debtorEmail'),
      debtorPhone: v => this.validateEmpty(v, 'debtorPhone'),
      companyOperationId: v => this.validateEmpty(v, 'companyOperationId'),
      periodicity: v => this.validateEmpty(v, 'periodicity'),
      termAsMonths: v => this.validateEmpty(v, 'termAsMonths'),
      graceMonths: v => this.validateEmpty(v, 'graceMonths')
    };
    return commonFields;
  }

  validateOperationDate(val, key, acceptEmpty) {
    if (acceptEmpty && val === undefined) return val;
    if (!this.validateDate(val)) throw new Error(`invalid ${key} '${val}'`);
    return val;
  }

  validateConsiderLates(val, key, operation) {
    const errorMessage = `considerLate not allowed with considerLateInterst or considerLateCharges at operation ${operation.companyOperationId}`;

    if (key === 'considerLate' && val !== undefined) {
      if (operation.considerLateInterest !== undefined || operation.considerLateCharges !== undefined) throw new Error(errorMessage);
    } else if ((key === 'considerLateInterest' || key === 'considerLateCharges') && val !== undefined) {
      if (operation.considerLate !== undefined || operation.considerLateInterest === undefined || operation.considerLateCharges === undefined) throw new Error(errorMessage);
    } else if (operation.considerLate === undefined && operation.considerLateCharges === undefined && operation.considerLateInterest === undefined) {
      throw new Error(`Operation ${operation.companyOperationId} should have considerLate or considerLateInterest and considerLateCharges`);
    }
    return val;
  }

  validateAccordingLoadTD(val, key, operation) {
    const { loadTD } = operation;
    if (loadTD === 'FALSE') { return this.validateEmpty(val, key); }
    return undefined;
  }

  validateEmpty(val, key) { if (val === undefined) throw new Error(`invalid ${key}`); return val; }

  validateDate(val) {
    if (typeof val !== 'string') return false;
    const [year, month, day] = val.split('-');
    if (year.length !== 4 || month.length !== 2 || day.length !== 2) return false;
    if (Number(month) === 0 || Number(month) > 12) return false;
    if (Number(day) === 0 || Number(day) > 32) return false;
    return true;
  }

  validatePayments(payments, operation) {
    const { type, loadTD } = operation;
    if (loadTD === 'FALSE') return payments;
    if (!Array.isArray(payments) || payments.length !== Number(operation.termAsMonths)) {
      throw new Error(`Invalid payments for operation ${operation.companyOperationId}, must have length ${operation.termAsMonths}`);
    }

    const keys = ['paymentNumber', 'dueDate', 'monthlyPayment', 'interest', 'amortization', 'balance', 'isPaid'];
    if (type === 'PARKING') keys.push('spread');
    payments.forEach(payment => {
      keys.forEach(key => {
        const paymentKeys = Object.keys(payment);
        if (!paymentKeys.includes(key)) throw new Error(`invalid ${key} at operation ${operation.companyOperationId} payment ${payment.paymentNumber}`);
      });
      // Validación dueDate
      const { dueDate } = payment;
      const errorDueDateMessage = `invalid dueDate '${dueDate}' at operation ${operation.companyOperationId} payment ${payment.paymentNumber}`;
      if (!this.validateDate(dueDate)) throw new Error(errorDueDateMessage);
    });
    return payments;
  }

  applyValidations(operation) {
    const { type, country } = operation;
    const validationObject = Object.assign(this.getCommonmFields(), this.validations[country][type]);
    const operationOutPut = operation;
    Object.entries(validationObject).forEach(([key, validator]) => {
      operationOutPut[key] = validator(operation[key], operation);
    });
    return operationOutPut;
  }
}
